export const PL = {
  "Open document": "OtwÃ³rz dokument",
  "Upload file": "PrzesyÅanie pliku",
  "Drop file here to upload": "UpuÅÄ plik tutaj, aby go przesÅaÄ",
  "Disc": "Dysk",
  "URL": "URL",
  "FILE": "PLIK",
  "SIZE": "ROZMIAR",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bajty",
  "Loading... Please wait.": "Åadowanie proszÄ czekaÄ.",
  "Fit Width": "Dopasuj szerokoÅÄ",
  "Fit Height": "Dopasuj wysokoÅÄ",
  "Password protected document": "Dokument chroniony hasÅem",
  "Password": "HasÅo",
  "Open": "otwarty",
  "Password Required": "Wymagane hasÅo",
  "Incorrect password": "niepoprawne hasÅo",
  "Error": "BÅÄd",
  "Something went wrong": "CoÅ poszÅo nie tak",
  "Server is not available": "Serwer jest niedostÄpny",
  "of": "z",
  "Please wait...": "ProszÄ czekaÄ..."
};
